import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { LoadingCard } from '@/components/Loading/LoadingCard';
import { Text } from '@/components/Typography/Text/Text';
import { useTransactionLocale } from '@/hooks/useTranslationLocale';
import { trackPageView } from '@/lib/tagging';
import { PasskeyForm } from '@/screens/passkey-enrollment/components/PasskeyForm';
import { usePasskeyEnrollmentManager } from '@/screens/passkey-enrollment/hooks/usePasskeyEnrollmentManager';

function PasskeyEnrollment() {
  const { t } = useTranslation('passkeyEnrollment');
  const { abortPasskeyEnrollment, shouldAbortEnrollment } =
    usePasskeyEnrollmentManager();

  useTransactionLocale();

  useEffect(() => {
    if (shouldAbortEnrollment) {
      void abortPasskeyEnrollment();
    } else {
      trackPageView('mfa/passkey/setup');
    }
  }, [abortPasskeyEnrollment, shouldAbortEnrollment]);

  if (shouldAbortEnrollment) {
    return <LoadingCard />;
  }

  return (
    <BaseWrapper title={t('header')}>
      <Text align="center" className="u-margin-b-l">
        {t('info')}
      </Text>
      <PasskeyForm />
    </BaseWrapper>
  );
}

export default PasskeyEnrollment;
